import { Controller } from "@hotwired/stimulus"

// Auto-submits the filter form when any select or radio changes.
// On mobile, toggles the filter panel open/closed.
export default class extends Controller {
  static targets = ["panel", "toggleIcon"]

  submit() {
    this.element.requestSubmit()
  }

  toggle() {
    if (this.hasPanelTarget) {
      const hidden = this.panelTarget.classList.toggle("hidden")
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.style.transform = hidden ? "" : "rotate(180deg)"
      }
    }
  }
}
